<template>
    <div>
        <v-row no-gutters>
            <v-col
                :cols="colWidth"
                v-for="(connection, index) of connectors_"
                :key="index"
                class="my-2"
            >
                <SettingConnector
                    v-bind="connection"
                    :active="connection.isActive || false"
                    :enableSync="connection.enableSync || false"
                    :companyId="companyId"
                    :comingSoon="connection.comingSoon || false"
                    :logo="getLogo(connection.application) || ''"
                    :externalId="connection.externalId || ''"
                    :disableConfiguration="connection.disableConfiguration || false"
                    :dense="dense"
                    @updateProfile="(configValue) => upsertSetting(configValue)"
                    @connector-deleted="(connectorId) => removeDeleted(connectorId)"
                />
            </v-col>
            <v-col
                :cols="colWidth"
                v-for="account in connectedBankAccounts"
                :key="account.id"
                class="my-2"
            >
                <ConnectedBankAccountCard
                    v-if="account.budgetInsightId"
                    :bankAccount="account"
                    :dense="dense"
                />
            </v-col>
            <v-col :cols="colWidth" class="my-2" v-if="displayAddConnectorCard">
                <v-card
                    class="d-flex align-end flex-column default_card elevation-0 fill-height mx-2"
                >
                    <v-tooltip v-if="isTrainingOffer">
                        <template #activator="{ props }">
                            <v-card-text
                                v-bind="props"
                                class="fill-height d-flex align-center justify-center w-100"
                            >
                                <v-btn :disabled="true" size="small">
                                    <v-icon class="mr-2">$fa-plus</v-icon>
                                    Ajouter un connecteur
                                </v-btn>
                            </v-card-text>
                        </template>
                        <span>{{ $t("training-text.normal-text") }}</span>
                    </v-tooltip>
                    <v-card-text
                        v-else
                        class="fill-height d-flex align-center justify-center w-100"
                    >
                        <v-btn @click="addConnector = true" size="small">
                            <v-icon class="mr-2">$fa-plus</v-icon>
                            Ajouter un connecteur
                        </v-btn>
                    </v-card-text>
                </v-card>
                <oss-dialog v-model="addConnector">
                    <div style="min-width: 40vw">
                        <AddConnector :companyId="companyId" />
                    </div>
                </oss-dialog>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import COMPANY_CONNECTORS from "@/graphql/connector/GetCompanyConnectors.gql";

import { ConnectorServices } from "@/services/connectorServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { Emit } from "vue-facing-decorator";

import { ConnectedBankAccount } from "@/types/bankAccounts.types";
import SettingConnector from "../settings/SettingConnector.vue";
import AddConnector from "./AddConnector.vue";
import ConnectedBankAccountCard from "./ConnectedBankAccountCard.vue";
import { Offer_type } from "@/types/offer.types";

@Component({
    components: {
        AddConnector,
        ConnectedBankAccountCard,
        SettingConnector,
    },
})
export class CompanyConnectors extends Vue {
    @Model({ type: Array, default: [], name: "connectors" }) inConnectors!: any[];
    @Prop({ required: true }) companyId!: string;
    @Prop({ default: [] }) connectedBankAccounts!: ConnectedBankAccount[];
    @Prop({ default: 3 }) connectorsPerLine!: number;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) displayAddConnectorCard: boolean;

    get offerType(): Offer_type {
        return this.$store.state.offerType;
    }

    get isTrainingOffer(): boolean {
        if (this.offerType === Offer_type.TRAINING) {
            return true;
        }
        return false;
    }

    get colWidth() {
        return 12 / this.connectorsPerLine;
    }

    addConnector: boolean = false;

    @Apollo({
        query: COMPANY_CONNECTORS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId || this.inConnectors?.length > 0;
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                if (data) {
                    this.connections = data.getCompanyConnectors.connectors;
                    debugger;
                } else {
                    this.connections = [];
                }
            }
        },
    })
    connectors_: any[] = [];

    getLogo(application: string) {
        return ConnectorServices.getLogo(application);
    }

    @Emit("updateProfile")
    upsertSetting(configValue: any) {
        return configValue;
    }

    @Watch("inConnectors", { immediate: true, deep: true })
    onInConnectorsChange() {
        this.connectors_ = this.inConnectors;
    }

    removeDeleted(connectorId) {
        this.connectors_ = this.connectors_.filter((c) => c.id !== connectorId);
    }
}

export default toNative(CompanyConnectors);
</script>
